import React from 'react';
import { string } from 'prop-types';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { Hydrator } from '@thd-olt-component-react/hydrator';
import { Spotlight as SpotlightComponent } from '@thd-olt-component-react/spotlight';

import classnames from 'classnames/bind';
import componentStyles from './components.module.scss';

const styles = classnames.bind(componentStyles);

const SpotlightPropTypes = {
  id: string,
};

const SpotlightDefaultProps = {
  id: undefined,
};

export function CustomRenderedSpotlight({
  SCROLL_BUFFER,
  HOMEPAGE_DELAY_STANDARD,
  PLACEHOLDER,
}) {
  function Spotlight({ id }) {
    return (
      <QueryProvider key={id} cacheKey={id}>
        <Hydrator
          id={`${id}-spotlight-php-hydrator`}
          className={styles('u-height-100', 'hydrator--flex')}
          scrollBuffer={SCROLL_BUFFER}
          delay={HOMEPAGE_DELAY_STANDARD}
          placeholder={PLACEHOLDER}
        >
          <SpotlightComponent
            componentId={id}
            componentClass="Spotlight"
            showDescription
            boldTitle
          />
        </Hydrator>
      </QueryProvider>
    );
  }

  Spotlight.propTypes = SpotlightPropTypes;
  Spotlight.defaultProps = SpotlightDefaultProps;

  return Spotlight;
}
